import { render, staticRenderFns } from "./NovedadesOperativas.vue?vue&type=template&id=120c9e2e&scoped=true"
import script from "./NovedadesOperativas.vue?vue&type=script&lang=js"
export * from "./NovedadesOperativas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c9e2e",
  null
  
)

export default component.exports